





























import { Component, Prop } from 'vue-property-decorator';
import { Factory, IAgencyPlan } from 'admiral-core';
import Multiselect from 'vue-multiselect';
import Avatar from '@/components/common/Avatar.vue';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { CheckIcon } from 'vue-feather-icons';
import { FormatMixin } from '@/mixins/FormatMixin';
import { Util } from '@/utils/Util';

@Component({
  components: { Multiselect, Avatar, CheckIcon },
})
export default class AgencyPlanSelect extends mixins(BaseMixin, FormatMixin) {
  @Prop()
  plan!: IAgencyPlan;

  updatePlan(plan: IAgencyPlan) {
    this.$emit('update-plan', plan);
  }

  get options() {
    return [Factory.buildCorePlan(), Factory.buildAllianzPlan()];
  }
  label(plan: IAgencyPlan) {
    return Util.formatAgencyPlan(plan.name);
  }

  isSelected(plan: IAgencyPlan) {
    return !!(plan?.name === this.plan?.name);
  }
}
